import { isRunningAsMeticulousTest } from "@/integrations/meticulous";

export interface LaunchDarklyFeatureFlags {
  infoBannerText: string;
  synopsis: boolean;
  isMultilingualSupportEnabled: boolean;
  povs: boolean;
  themes: boolean;
  manuscriptDeletion: boolean;
  inAppFeedback: boolean;
  manuscriptSharing: boolean;
  characters: boolean;
  worldAndSettings: boolean;
  tropes: boolean;
}

export function parseFeatureFlags(
  flags: Partial<LaunchDarklyFeatureFlags>,
  unknownFlagValue = isRunningAsMeticulousTest,
) {
  return {
    infoBannerText: flags.infoBannerText ?? "",
    synopsis: flags.synopsis ?? unknownFlagValue,
    isMultilingualSupportEnabled:
      flags.isMultilingualSupportEnabled ?? unknownFlagValue,
    povs: flags.povs ?? unknownFlagValue,
    themes: flags.themes ?? unknownFlagValue,
    manuscriptDeletion: flags.manuscriptDeletion ?? unknownFlagValue,
    inAppFeedback: flags.inAppFeedback ?? unknownFlagValue,
    manuscriptSharing: flags.manuscriptSharing ?? unknownFlagValue,
    characters: flags.characters ?? unknownFlagValue,
    worldAndSettings: flags.worldAndSettings ?? unknownFlagValue,
    tropes: flags.tropes ?? unknownFlagValue,
  };
}

export type FeatureFlags = ReturnType<typeof parseFeatureFlags>;

export const awaitWithTimeout = (
  fn: () => Promise<unknown>,
  timeout: number,
  timeoutMessage?: string,
) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error(timeoutMessage ?? `Awaiting ${fn.name} timeout`));
    }, timeout);
    fn().then(resolve).catch(reject);
  });
};
